export default __webpack_public_path__ + "static/media/team1.0abe37a6.jpg";